import { useQuery } from "@tanstack/react-query";
import { api } from "../../libs/axios";
import { AgenciaAfiliada } from "../../utils/interfaces";

async function getAgenciasAfiliadas(): Promise<AgenciaAfiliada[]> {
  const response = await api.get("/agencias/afiliadas").then((res) => res.data);

  return response.data;
}

export function useAgenciasAfiliadas() {
  return useQuery({
    queryKey: ["agencias-afiliadas"],
    queryFn: getAgenciasAfiliadas,
    staleTime: 1,
    gcTime: 1,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
